import { render } from "./UploadSection.vue?vue&type=template&id=dc70c1e8&scoped=true"
import script from "./UploadSection.vue?vue&type=script&lang=js"
export * from "./UploadSection.vue?vue&type=script&lang=js"

import "./UploadSection.vue?vue&type=style&index=0&id=dc70c1e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc70c1e8"]])

export default __exports__